import {
  PUBLIC_SYSTEM_SETTINGS_STORAGE_KEY,
  readStoredPublicSystemSettings,
} from '@/shared/helpers/system-setting-cache'
import type { SystemSettingPublic } from '@/shared/types/system-setting.type'

export function installSystemSettingSyncListener(
  onSettingsChanged: (settings: SystemSettingPublic) => void,
) {
  const onStorage = (event: StorageEvent) => {
    if (!event.newValue) return
    if (
      event.key !== PUBLIC_SYSTEM_SETTINGS_STORAGE_KEY &&
      !event.key?.startsWith(`${PUBLIC_SYSTEM_SETTINGS_STORAGE_KEY}.`)
    ) {
      return
    }

    try {
      const settings = JSON.parse(event.newValue) as SystemSettingPublic
      if (settings && typeof settings === 'object') {
        onSettingsChanged(settings)
      }
    } catch {
      const cached = readStoredPublicSystemSettings()
      if (cached) onSettingsChanged(cached)
    }
  }

  window.addEventListener('storage', onStorage)

  return () => window.removeEventListener('storage', onStorage)
}
